import { render, staticRenderFns } from "./DistributionWeightStudentList.vue?vue&type=template&id=00614668&scoped=true"
import script from "./DistributionWeightStudentList.vue?vue&type=script&lang=js"
export * from "./DistributionWeightStudentList.vue?vue&type=script&lang=js"
import style0 from "./DistributionWeightStudentList.vue?vue&type=style&index=0&id=00614668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00614668",
  null
  
)

export default component.exports